/**
 * CRM PdfBeyanname API (C#: RoutePrefix api/pdf-beyanname)
 * Yerel test: REACT_APP_PDF_BEYANNAME_API_URL=http://localhost:5205/api/pdf-beyanname
 */
const trimEndSlash = (s) => (s || "").replace(/\/+$/, "");

const rawBase =
  process.env.REACT_APP_PDF_BEYANNAME_API_URL ||
  //"http://localhost:5205/api/pdf-beyanname";
 // "http://beyanname.in/api/pdf-beyanname";
  "https://beyannameservice.tcisigorta.com/api/pdf-beyanname";

export const PDF_BEYANNAME_API_BASE = trimEndSlash(rawBase);

export const PDF_BEYANNAME_API_KEY = (
  process.env.REACT_APP_PDF_BEYANNAME_API_KEY || ""
).trim();

export function pdfBeyannameHeaders(extra) {
  const headers = extra ? { ...extra } : {};
  if (PDF_BEYANNAME_API_KEY)
    headers["X-Api-Key"] = PDF_BEYANNAME_API_KEY;
  return headers;
}

export async function downloadPdfBeyannameExcel(fileName) {
  const response = await fetch(pdfBeyannameDownloadUrl(fileName), {
    headers: pdfBeyannameHeaders(),
  });
  if (!response.ok) {
    if (response.status === 401)
      throw new Error("API anahtarı geçersiz veya eksik.");
    throw new Error(`İndirme hatası (${response.status})`);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "output.xlsx";
  link.click();
  URL.revokeObjectURL(url);
}

/** @param {string} path ör. "upload", "download/foo.xlsx", "download-status" */
export function pdfBeyannameUrl(path) {
  const p = (path || "").replace(/^\/+/, "");
  return `${PDF_BEYANNAME_API_BASE}/${p}`;
}

/** IIS, yolda .xlsx olan GET isteğini statik dosya sanıyor; sorgu parametresi kullan. */
export function pdfBeyannameDownloadUrl(fileName) {
  const q = encodeURIComponent(fileName || "");
  return `${PDF_BEYANNAME_API_BASE}/download?fileName=${q}`;
}

export function pdfBeyannameDeleteUrl(fileName) {
  const q = encodeURIComponent(fileName || "");
  return `${PDF_BEYANNAME_API_BASE}/delete?fileName=${q}`;
}
